import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { CREATE_OWNER } from "../../actions/mutations";
import { useNavigate, Link } from "react-router-dom";
import NavbarAccount from "../Layout/Navbar_account";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
// import { togglePassword } from "../../utils/togglePassword";
import editElem from "../../utils/editElem";

let emoji = Math.random() < 0.5 ? "😍" : "🎯";

const CreateOwnerPage = () => {
  const navigate = useNavigate();
  if (sessionStorage.getItem("loggedIn")) navigate("/mon-compte");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const [createOwner] = useMutation(CREATE_OWNER);

  const submitForm = (event) => {
    event.preventDefault();
    editElem("#login", "disabled", true);
    editElem(".smallLoader2", "display", "block");

    let error = false;
    const formattedEmail = email.trim().toLowerCase();

    if (name.length === 0) {
      editElem(".nameError", "display", "block");

      error = true;
    }
    if (
      !formattedEmail
        .toLocaleLowerCase()
        .match(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
        )
    ) {
      editElem(".emailError", "display", "block");

      error = true;
    }
    if (!document.querySelector("#cguCheckbox").checked) {
      editElem(".cguError", "display", "block");
      error = true;
    }

    if (error) {
      editElem("#login", "disabled", false);
      editElem(".smallLoader2", "display", "none");
    } else
      createOwner({
        variables: {
          data: {
            name: name.trim(),
            email: formattedEmail,
            // password,
          },
        },
      })
        .then((response) => {
          editElem(".success", "display", "block");
          editElem("#login", "disabled", false);
          editElem(".smallLoader2", "display", "none");
          if (window.location.hostname == "www.carteverte.co") {
            window.dataLayer = window.dataLayer || [];
            function gtag() {
              window.dataLayer.push(arguments);
            }
            gtag("event", "sign_up", {
              method: "Direct",
            });
          }
        })
        .catch((e) => {
          sessionStorage.removeItem("loggedIn");
          console.log(e.toString().split("\n")[0]);
          console.log(e.toString());
          if (
            e
              .toString()
              .includes("A unique constraint would be violated on Owner")
          ) {
            editElem(".uniqueConstraintError", "display", "block");
          } else if (
            e.toString().includes("Looks like an internal server error") ||
            e.toString().includes("Failed to fetch")
          ) {
            editElem(".networkError", "display", "block");
            console.warn("Vérifer votre connexion internet");
          } else if (e.toString().includes("NetworkError")) {
            editElem(".serverNetworkError", "display", "block");
            console.warn(
              " Notre serveur est déconnecté. Veuillez réessayer plus tard et nous contacter si cela persiste! contact@carteverte.co"
            );
          }
          editElem("#login", "disabled", false);
          editElem(".smallLoader2", "display", "none");
        });
  };
  document.title = "Carte Verte : Adhésion";

  return (
    <div id="loginContainer">
      <NavbarAccount isActive="hidden" cta="no" />

      <div id="imgContainer">
        <Link to="/#">
          <img
            className="logoLoginSignup"
            src="/images/icon-blanche.png"
            alt=""
          />
        </Link>
      </div>
      <Link className="returnLink" to="/#">
        <FontAwesomeIcon
          icon={faArrowLeft}
          style={{ fontSize: "1.4rem", marginRight: "1rem" }}
        />
        Accueil
      </Link>
      <div id="formContainer">
        <form id="form" onSubmit={submitForm}>
          <div id="formHeader">
            <h1 style={{ marginBottom: "2rem", textAlign: "center" }}>
              Créer un compte
            </h1>
            <h1 id="bonjour">Hello!</h1>
            <h1 id="welcom">
              Vous êtes sur le point de donner un nouvel élan à la fidélité{" "}
            </h1>
            <span> {emoji}</span>
          </div>

          <div id="emailContainer">
            <p>EMAIL</p>
            <input
              placeholder="Utilisé seulement pour vous connecter"
              type="text"
              onChange={(event) => {
                editElem(".emailError", "display", "none");
                editElem(".uniqueConstraintError", "display", "none");
                editElem(".success", "display", "none");

                // document.querySelector(".emailError").style.display = "none";
                // document.querySelector(".uniqueConstraintError").style.display =
                //   "none";
                // document.querySelector(".success").style.display = "none";
                setEmail(event.target.value);
              }}
            />
            <p className="error emailError">Email invalide !</p>
          </div>
          <div id="nameContainer">
            <p>NOM DU COMMERCE</p>
            <input
              placeholder="Nom de votre commerce"
              type="text"
              onChange={(event) => {
                editElem(".nameError", "display", "none");

                // document.querySelector(".nameError").style.display = "none";
                setName(event.target.value);
              }}
            />
            <p className="error nameError">Le nom est obligatoire !</p>
          </div>
          {/* <div id="passwordContainer">
            <p>MOT DE PASSE</p>
            <input
              id="psw"
              placeholder="8 caractères ou plus"
              type="password"
              onChange={(event) => {
                document.querySelector(".passwordError").style.display = "none";
                setPassword(event.target.value);
              }}
            />
            <p id="display" onClick={togglePassword}>
              AFFICHER
            </p>
            <p id="hide" onClick={togglePassword}>
              CACHER
            </p>
            <p className="error passwordError">
              Le mot de passe doit contenir 8 caractères ou plus
            </p>
          </div> */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              id="cguCheckbox"
              name="cgu"
              style={{ width: "10%"}}
              // checked={false}
              onChange={(event) => {
                editElem(".cguError", "display", "none");

                // setDefaultCheckedValue(false);
                // setOfferMsgsCheckboxChecked(event.target.checked);
                // const timeout = event.target.checked ? 0 : 500;
                // handleOfferMsgs(event.target.checked, offer, timeout);
              }}
            />
            <p style={{ fontSize: "1rem", marginLeft: "1rem" }}>
              En cochant cette case, je reconnais avoir pris connaissance des{" "}
              <b>
                <i>
                  <u>
                    <a href="/cgu" target="_blank" rel="noopener noreferrer">
                      Conditions Générales d'Utilisation
                    </a>
                  </u>
                </i>
              </b>.
              {" "}
              Le service Carte Verte demeure gratuit. Toute modification de
              notre politique tarifaire vous sera communiquée au moins 30 jours
              à l'avance ✨.
            </p>
          </div>
          <p className="error cguError">Vous devez accepter les CGU !</p>
          <p>
            <button
              id="login"
              type="submit"
              style={{
                alignItems: "center",
                display: "flex",
                justifyContent: "space-around",
                marginTop: "2rem",
                width: "23rem",
              }}
            >
              Créer mon compte
              <div className="smallLoader2"></div>
            </button>
          </p>
          <p className="error uniqueConstraintError">
            Un compte existe déjà pour cette adresse mail !
          </p>
          <p className="error networkError">
            Veuillez vérifier votre connexion internet !
          </p>
          <p className="error networkError serverNetworkError">
            Notre serveur est déconnecté. Veuillez réessayer plus tard et nous
            contacter si cela persiste! contact@carteverte.co
          </p>
          <p className="success">
            Un mot passe vient de vous être envoyé par email.
            <br />{" "}
            <span style={{ fontSize: "1rem", color: "var(--color-grey)" }}>
              Veuillez vérifier dans les spams également.
            </span>
            <br />
            <br /> Utlisez ce mot de passe pour{" "}
            <Link
              style={{
                color: "var(--color-secondary)",
                textDecoration: "underline",
              }}
              to="/login"
            >
              vous connecter
            </Link>
            <br /> et pensez à le changer par la suite.
          </p>
        </form>
      </div>
      <p id="noAccount">
        Vous avez déjà un compte ?{" "}
        <span role="img" aria-label="">
          😎
        </span>{" "}
        <span>
          <Link to="/login">Connectez-vous.</Link>
        </span>
      </p>
    </div>
  );
};

export { CreateOwnerPage as default };
